import {
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  Output,
} from '@angular/core';

export interface TasksCustomSelectOption {
  value: string | number;
  label: string;
}

@Component({
  selector: 'hour4u-admin-tasks-custom-select',
  templateUrl: './tasks-custom-select.component.html',
  styleUrls: ['./tasks-custom-select.component.scss']
})
export class TasksCustomSelectComponent {
  @Input() options: TasksCustomSelectOption[] = [];
  @Input() value: string | number = '';
  @Input() disabled = false;
  @Input() compact = false;
  @Input() placeholder = 'Select';

  @Output() valueChange = new EventEmitter<string | number>();

  isOpen = false;

  constructor(private elementRef: ElementRef) { }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    if (!this.isOpen) {
      return;
    }
    if (!this.elementRef.nativeElement.contains(event.target as Node)) {
      this.isOpen = false;
    }
  }

  get selectedLabel(): string {
    const match = this.options.find((option) => this.isSameValue(option.value, this.value));
    return match ? match.label : this.placeholder;
  }

  toggleDropdown(event: Event) {
    event.stopPropagation();
    if (this.disabled || !this.options.length) {
      return;
    }
    this.isOpen = !this.isOpen;
  }

  selectOption(optionValue: string | number, event?: Event) {
    if (event) {
      event.stopPropagation();
    }
    this.isOpen = false;
    if (!this.isSameValue(optionValue, this.value)) {
      this.valueChange.emit(optionValue);
    }
  }

  isSelected(optionValue: string | number): boolean {
    return this.isSameValue(optionValue, this.value);
  }

  private isSameValue(left: string | number, right: string | number): boolean {
    return String(left) === String(right);
  }
}
